import { AnyAction } from 'redux';
import {
    GET_UNITS_BY_LOCATION_ID_FAILURE,
    GET_UNITS_BY_LOCATION_ID_REQUEST,
    GET_UNITS_BY_LOCATION_ID_SUCCESS,
    REMOVE_PREVIOUS_DATA,
    SYNC_UNIT_FAILURE,
    SYNC_UNIT_SUCCESS,
    SYNC_UNIT_REQUEST,
} from '../constants/unitsByLocationId';

const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
    syncUnit: {
        loading: false,
        data: [],
        errorMsg: '',
    },
};

export const unitByLocationIdReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GET_UNITS_BY_LOCATION_ID_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_UNITS_BY_LOCATION_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                errorMsg: '',
            };
        case GET_UNITS_BY_LOCATION_ID_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };
        case REMOVE_PREVIOUS_DATA:
            return {
                ...state,
                data: [],
            };
        case SYNC_UNIT_REQUEST:
            return {
                ...state,
                syncUnit: {
                    ...state.syncUnit,
                    loading: true,
                },
            };
        case SYNC_UNIT_SUCCESS:
            return {
                ...state,
                syncUnit: {
                    ...state.syncUnit,
                    loading: false,
                },
            };
        case SYNC_UNIT_FAILURE:
            return {
                ...state,
                syncUnit: {
                    ...state.syncUnit,
                    loading: false,
                },
            };
        default:
            return state;
    }
};
